import { useEffect, useState } from "react";
import ReactQuill from "react-quill-new";

import 'react-quill-new/dist/quill.bubble.css';
import '../styles/quill.scss'
import { convertToQuillDelta, hasQuillTextContent } from "../../../global/helpers/global-helpers";

import { Box } from "@chakra-ui/react";

export default function LaunchdeckDisplayTextArea({ isMobileView, deltaContent, cursor, placeholder, isTile, children }) {

  const [usePlaceholder, setUsePlaceholder] = useState(false)
  const [contentToDisplay, setContentToDisplay] = useState("")

  useEffect(() => {

    if (hasQuillTextContent(deltaContent)) {
      const contentToDisplay = convertToQuillDelta(deltaContent)
      setUsePlaceholder(false)
      setContentToDisplay(contentToDisplay)
    } else {
      setUsePlaceholder(true)
      setContentToDisplay(null)
    }
  }, [deltaContent]);

  useEffect(() => {
    const editorContainer = document.querySelector(".ql-editor");

    if (!editorContainer) return;
    // Toggle the 'tile' class based on isTile
    if (isTile) {
      editorContainer.classList.add("tile");
    } else {
      editorContainer.classList.remove("tile");
    }
  }, [isTile]); // Runs whenever isTile changes


  return (
    <Box cursor={cursor && cursor} >
      {usePlaceholder ? children ? children :
        <Box
          p='0.9em 1em'
          fontSize='0.875em'
          color='gray.500'
          fontStyle='italic'
          bg='white'
          border='1px solid #d4d4d8'
          rounded='0.5em'
        >
          {placeholder ? placeholder : 'Add your text content here'}
        </Box>
        :
        <Box fontSize={isMobileView ? '14px' : '15px'}>
        <ReactQuill
          theme="bubble"
          placeholder={placeholder ? placeholder : 'Add your text content here'}
          value={contentToDisplay}  // Pass sanitized content (either the provided delta or default)
          readOnly={true}           // Set read-only mode
          modules={{ toolbar: false }}  // Disable the toolbar in read-only mode
          className={cursor === "pointer" && 'read-only-quill'}
          style={{
            backgroundColor: "#fff",
            borderRadius: "8px", // Rounded corners
            padding: "10px 0px"
          }}
        />
        </Box>
      }

    </Box>
  );
}
